var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 832,
    viewBox: "0 0 768 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 224C160 283.408 183.6 340.384 225.608 382.392C267.616 424.4 324.592 448 384 448C443.408 448 500.384 424.4 542.392 382.392C584.4 340.384 608 283.408 608 224C608 164.592 584.4 107.616 542.392 65.6081C500.384 23.5999 443.408 0 384 0C324.592 0 267.616 23.5999 225.608 65.6081C183.6 107.616 160 164.592 160 224ZM704 832H32C23.5131 832 15.3738 828.629 9.37259 822.627C3.37143 816.626 0 808.487 0 800V704C0 661.565 16.8571 620.869 46.8629 590.863C76.8687 560.857 117.565 544 160 544H608C650.435 544 691.131 560.857 721.137 590.863C751.143 620.869 768 661.565 768 704V800C768 808.487 764.629 816.626 758.627 822.627C752.626 828.629 744.487 832 736 832H704Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.7d133d6220ef1acb4e159b884fbbf935.svg";
export { ForwardRef as ReactComponent };